import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum(['NONE', 'CARD', 'CASH', 'MERCHANT_BILLING', 'RECEIPTS', 'APPOINTMENTS', 'MERCHANT_SETTLEMENT', 'INSTRUMENT_ON_FILE']);